import {
    Box,
    Button,
    Checkbox,
    Dialog,
    DialogContent,
    IconButton,
    Stack,
    Tooltip,
    Typography,
    useTheme,
} from "@mui/material";
import { useState } from "react";
import { HugeiconsIcon } from "@hugeicons/react";
import { CopyIcon } from "@hugeicons/core-free-icons";
import { openSnackbar } from "@/store/uiSlice";

interface ChromeFreezeDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => Promise<void>;
}

const ChromeFreezeDialog = ({
    open,
    onClose,
    onConfirm
}: ChromeFreezeDialogProps) => {
    const { palette } = useTheme();
    const [copied, setCopied] = useState(false);
    const [addedToExceptions, setAddedToExceptions] = useState(false);

    const exceptionUrl = window.location.origin;

    const handleCopy = async () => {
        await navigator.clipboard.writeText(exceptionUrl);
        setCopied(true);
        openSnackbar({
            message: "URL copiada al portapapeles",
            severity: "success",
        })
    };

    const handleOpenChromeSettings = async () => {
        try {
            await navigator.clipboard.writeText("chrome://settings/performance");

            alert(
                "Se copió la dirección. Ábrela en una pestaña nueva de Chrome y pega la dirección."
            );
        } catch {
            alert(
                "Abre una pestaña nueva en Chrome y escribe: chrome://settings/performance"
            );
        }
    };


    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="xs"
            fullWidth
            disableEscapeKeyDown

        >
            <Box
                sx={{
                    height: 140,
                    background:
                        "linear-gradient(135deg, #172b4d 0%, #4b6584 100%)",
                }}
            />

            <DialogContent sx={{ p: 2.5 }}>
                <Stack spacing={2}>

                    <Stack spacing={1} justifyContent={"center"} alignItems={"center"}>
                        <Typography variant="h3" >
                            ¡Tu sesión ha vuelto a la vida!
                        </Typography>

                        <Typography variant="body2" color="text.secondary">
                            Chrome suspendió esta página para ahorrar recursos. Para
                            evitar que vuelva a suceder, agrega nuestra URL a las
                            excepciones de tu navegador.
                        </Typography>
                    </Stack>

                    <Box
                        sx={{
                            borderTop: "1px solid",
                            borderColor: "divider",
                            pt: 2,
                        }}
                    >
                        <Typography
                            variant="caption"
                            fontWeight={700}
                            color="text.secondary"
                            textTransform={"capitalize"}
                        >
                            Pasos para añadir excepción
                        </Typography>

                        <Stack spacing={1.5} mt={1.5}>
                            <Stack direction="row" spacing={1.5} alignItems="center">
                                <Box
                                    sx={{
                                        width: 24,
                                        height: 24,
                                        borderRadius: "50%",
                                        bgcolor: "#eeeeee",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontSize: 12,
                                        fontWeight: 700,
                                    }}
                                >
                                    <Typography>1</Typography>
                                </Box>

                                <Typography variant="body2">
                                    Abre una nueva pestaña{" "}
                                    <strong>chrome://settings/performance</strong>
                                </Typography>

                                <Tooltip title="Copiar" placement="top">
                                    <IconButton
                                        onClick={handleOpenChromeSettings}
                                    >
                                        <HugeiconsIcon icon={CopyIcon} color={palette.primary.main} />
                                    </IconButton>
                                </Tooltip>
                            </Stack>

                            <Stack direction="row" spacing={1.5} alignItems="center">
                                <Box
                                    sx={{
                                        width: 24,
                                        height: 24,
                                        borderRadius: "50%",
                                        bgcolor: "#eeeeee",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontSize: 12,
                                        fontWeight: 700,
                                    }}
                                >
                                    <Typography>2</Typography>
                                </Box>

                                <Typography variant="body2">
                                    Haz clic en <strong>Añadir</strong> y pega la URL de abajo.
                                </Typography>
                            </Stack>

                            <Box
                                sx={{
                                    bgcolor: "#f5f5f7",
                                    borderRadius: 1.5,
                                    px: 1.5,
                                    py: 1,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                }}
                            >
                                <Typography
                                    variant="body2"
                                    color="primary"
                                    sx={{
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    {exceptionUrl}
                                </Typography>

                                <IconButton onClick={handleCopy}>
                                    <HugeiconsIcon icon={CopyIcon} />
                                </IconButton>
                            </Box>

                            <Stack direction="row" alignItems="center">
                                <Checkbox
                                    size="small"
                                    checked={addedToExceptions}
                                    onChange={(event) =>
                                        setAddedToExceptions(event.target.checked)
                                    }
                                />

                                <Typography variant="caption">
                                    Ya agregué el sitio a mis excepciones
                                </Typography>
                            </Stack>

                            <Button
                                variant="contained"
                                color="success"
                                disabled={!addedToExceptions}
                                onClick={onConfirm}
                                sx={{ alignSelf: "flex-end" }}
                            >
                                Listo
                            </Button>
                        </Stack>
                    </Box>
                </Stack>
            </DialogContent>
        </Dialog>
    );
};

export default ChromeFreezeDialog;